import { render, staticRenderFns } from "./MainRightBody.vue?vue&type=template&id=571cf29f&"
import script from "./MainRightBody.vue?vue&type=script&lang=js&"
export * from "./MainRightBody.vue?vue&type=script&lang=js&"
import style0 from "./MainRightBody.vue?vue&type=style&index=0&id=571cf29f&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports